import { z } from "zod";
import { Id, IsoDateTime } from "./common";

export const TenantType = z.enum([
  "InternalDepartment",
  "Customer",
  "Demo",
  "Enterprise",
]);
export type TenantType = z.infer<typeof TenantType>;

export const TenantStatus = z.enum(["Active", "Disabled", "Archived"]);
export type TenantStatus = z.infer<typeof TenantStatus>;

export const Tenant = z.object({
  tenantId: Id,
  tenantType: TenantType,
  displayName: z.string().min(1).max(120),
  legalName: z.string().min(1).max(200),
  status: TenantStatus,
  primaryContactUserId: Id.nullable(),
  createdAt: IsoDateTime,
  updatedAt: IsoDateTime,
  createdBy: Id.nullable(),
  updatedBy: Id.nullable(),
});
export type Tenant = z.infer<typeof Tenant>;

export const TenantCreateInput = z.object({
  tenantType: TenantType,
  displayName: z.string().min(1).max(120),
  legalName: z.string().min(1).max(200),
});
export type TenantCreateInput = z.infer<typeof TenantCreateInput>;

export const TenantUpdateInput = z
  .object({
    displayName: z.string().min(1).max(120),
    legalName: z.string().min(1).max(200),
    status: TenantStatus,
    primaryContactUserId: Id.nullable(),
  })
  .partial();
export type TenantUpdateInput = z.infer<typeof TenantUpdateInput>;
